/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DebondingDelegation,
    DebondingDelegationFromJSON,
    DebondingDelegationFromJSONTyped,
    DebondingDelegationToJSON,
} from './';

/**
 * A list of debonding delegations.
 * @export
 * @interface DebondingDelegationListAllOf
 */
export interface DebondingDelegationListAllOf {
    /**
     * 
     * @type {Array<DebondingDelegation>}
     * @memberof DebondingDelegationListAllOf
     */
    debonding_delegations: Array<DebondingDelegation>;
}

export function DebondingDelegationListAllOfFromJSON(json: any): DebondingDelegationListAllOf {
    return DebondingDelegationListAllOfFromJSONTyped(json, false);
}

export function DebondingDelegationListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebondingDelegationListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'debonding_delegations': ((json['debonding_delegations'] as Array<any>).map(DebondingDelegationFromJSON)),
    };
}

export function DebondingDelegationListAllOfToJSON(value?: DebondingDelegationListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'debonding_delegations': ((value.debonding_delegations as Array<any>).map(DebondingDelegationToJSON)),
    };
}


